


















import { Component } from 'vue-property-decorator';
import Menu from '../components/Menu.vue';
import Footer from '@/components/Footer.vue';
import MainImage from '@/components/MainImage.vue';
import Exhibitor from '@/components/Exhibitor.vue';
import ExhibitorManager from '@/script/ExhibitorManager';
import PageVue from '@/script/PageVue';
import {Mixins} from 'vue-mixin-decorator';
import GimmickImageContainer from '@/components/GimmickImageContainer.vue';

@Component({
  components: {GimmickImageContainer, Exhibitor, MainImage, Footer, Menu },
})
export default class ExhibitorListPage extends Mixins<PageVue>(PageVue) {
  private exhibitorList = ExhibitorManager.INSTANCE.exhibitorList;
}
